import IoaWorkbenchError from './IoaWorkbenchError';

export default class ArgumentError extends IoaWorkbenchError {
  constructor(msg) {
    super(`ArgumentError: ${msg}`);
  }
}
